

export const updateReduxRestaurants = (restaurants) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.restaurants) !== JSON.stringify(restaurants)){
  		dispatch({ type: 'UPDATE_REDUX_RESTAURANTS_SUCCESS', payload:restaurants})  	
  	}    
  }
};

export const updateReduxUsers = (users) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.users) !== JSON.stringify(users)){
  		dispatch({ type: 'UPDATE_REDUX_USERS_SUCCESS', payload:users})  	
  	}    
  }
};

export const updateDashboard = (state) => {
  return (dispatch, getState) => {
    if(JSON.stringify(getState().reduxStore.dashboard) !== JSON.stringify(state)){
      dispatch({ type: 'UPDATE_REDUX_DASHBOARD_SUCCESS', payload:state})    
    }    
  }
};



export const updateReduxUser = (user) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.user) !== JSON.stringify(user)){
  		dispatch({ type: 'UPDATE_REDUX_USER_SUCCESS', payload:user})  	
  	}    
  }
};

export const updateReduxUserReviews = (userReviews) => {
  return (dispatch, getState) => {
    if(JSON.stringify(getState().reduxStore.userReviews) !== JSON.stringify(userReviews)){
      dispatch({ type: 'UPDATE_REDUX_USER_REVIEWS_SUCCESS', payload:userReviews})    
    }    
  }
};

export const updateReduxReviews = (restaurantReviews) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.restaurantReviews) !== JSON.stringify(restaurantReviews)){
  		dispatch({ type: 'UPDATE_REDUX_REVIEWS_SUCCESS', payload:restaurantReviews})  	
  	}    
  }
};

export const updateReduxPendingReviews = (pendingReviews) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.pendingReviews) !== JSON.stringify(pendingReviews)){
  		dispatch({ type: 'UPDATE_REDUX_PENDING_REVIEWS_SUCCESS', payload:pendingReviews})  	
  	}    
  }
};

export const updateReduxPending = (pending) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.pending) !== JSON.stringify(pending)){
  		dispatch({ type: 'UPDATE_REDUX_PENDING_SUCCESS', payload:pending})  	
  	}    
  }
};

export const updateReduxPendingCreate = (pendingCreate) => {
  return (dispatch, getState) => {
  	if(JSON.stringify(getState().reduxStore.pendingCreate) !== JSON.stringify(pendingCreate)){
  		dispatch({ type: 'UPDATE_REDUX_PENDING_CREATE_SUCCESS', payload:pendingCreate})  	
  	}    
  }
};